/* Gravur-MAX Startseite: Slider-Pfeile, Tabs, Gravur-Demo (Webstra 10/2026) */
(function(){
if(window.__wbHome)return;window.__wbHome=1;
function ready(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);}
function rails(root){
  (root||document).querySelectorAll('[data-wb-rail]').forEach(function(r){
    if(r.__wb)return;r.__wb=1;
    var t=r.querySelector('.wb-track'),p=r.querySelector('[data-wb-prev]'),n=r.querySelector('[data-wb-next]');
    if(!t)return;
    function step(){var c=t.firstElementChild;return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(t).columnGap||16):300;}
    function upd(){if(!p||!n)return;p.disabled=t.scrollLeft<4;n.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-4;}
    if(p)p.addEventListener('click',function(){t.scrollBy({left:-step()*2,behavior:'smooth'});});
    if(n)n.addEventListener('click',function(){t.scrollBy({left:step()*2,behavior:'smooth'});});
    t.addEventListener('scroll',function(){window.requestAnimationFrame(upd);},{passive:true});
    window.addEventListener('resize',upd);upd();
  });
}
function tabs(){
  document.querySelectorAll('[data-wb-tabs]').forEach(function(w){
    if(w.__wb)return;w.__wb=1;
    var bs=[].slice.call(w.querySelectorAll('[role=tab]'));
    function sel(b,focus){
      bs.forEach(function(x){var on=x===b;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;var pn=document.getElementById(x.getAttribute('aria-controls'));if(pn)pn.hidden=!on;});
      if(focus)b.focus();
      var pn=document.getElementById(b.getAttribute('aria-controls'));if(pn)rails(pn);
    }
    bs.forEach(function(b,i){
      b.addEventListener('click',function(){sel(b);});
      b.addEventListener('keydown',function(e){var k=e.key,j=-1;if(k==='ArrowRight')j=(i+1)%bs.length;if(k==='ArrowLeft')j=(i-1+bs.length)%bs.length;if(k==='Home')j=0;if(k==='End')j=bs.length-1;if(j>-1){e.preventDefault();sel(bs[j],true);}});
    });
  });
}
function demo(){
  document.querySelectorAll('[data-wb-demo]').forEach(function(d){
    if(d.__wb)return;d.__wb=1;
    var inp=d.querySelector('input'),out=d.querySelector('.wb-demo__text'),fb=[].slice.call(d.querySelectorAll('.wb-font'));
    var ph=out?out.textContent:'';
    function fit(){if(!out)return;out.style.transform='translate(-50%,-50%)';var max=out.parentNode.clientWidth*0.27,w=out.scrollWidth;out.style.transform='translate(-50%,-50%) scale('+(w>max?max/w:1)+')';}
    if(inp)inp.addEventListener('input',function(){out.textContent=inp.value.trim()||ph;fit();});
    fb.forEach(function(b){b.addEventListener('click',function(){fb.forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});out.style.fontFamily=b.style.fontFamily;setTimeout(fit,30);});});
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit);
    window.addEventListener('resize',fit);fit();
  });
}
ready(function(){rails();tabs();demo();});
document.addEventListener('shopify:section:load',function(){rails();tabs();demo();});
})();
